/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { labels } from '../labels/Labels';

interface IDetailHallAndBoothProps {
  hall: number | string;
  booth: number | string;
}

export default function DetailHallAndBooth(props: IDetailHallAndBoothProps) {
  return (
    <div className="hero-info">
      <div className="hero-info-item">
        <span className="label">{labels.hall}</span>
        <span className="value">{props.hall}</span>
      </div>
      <div className="hero-info-item">
        <span className="label">{labels.booth}</span>
        <span className="value">{props.booth}</span>
      </div>
    </div>
  );
}
